import {
  CREATE_INVITE_LINK_REQUEST,
  CREATE_INVITE_LINK_SUCCESS,
  CREATE_INVITE_LINK_FAILED,
  GET_DATA_FOR_INVITE_FORM_REQUEST,
  GET_DATA_FOR_INVITE_FORM_SUCCESS,
  GET_DATA_FOR_INVITE_FORM_FAILED,
  CLEAR_LINK,
} from './actionTypes';

const initialState = {
  loading: false,
  organizations: [],
  registrationForms: [],
  error: '',
  link: null,
};

const rolesSelectReducer = (state = initialState, {
  type, error, link, organizations, registrationForms,
}) => {
  switch (type) {
    case GET_DATA_FOR_INVITE_FORM_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_DATA_FOR_INVITE_FORM_SUCCESS:
      return {
        ...state,
        loading: false,
        organizations,
        registrationForms,
      };
    case GET_DATA_FOR_INVITE_FORM_FAILED:
      return {
        ...state,
        loading: false,
        error,
      };
    case CREATE_INVITE_LINK_REQUEST:
      return {
        ...state,
        loading: true,
        link: null,
      };
    case CREATE_INVITE_LINK_SUCCESS:
      return {
        ...state,
        loading: false,
        link,
      };
    case CREATE_INVITE_LINK_FAILED:
      return {
        ...state,
        error,
        loading: false,
      };
    case CLEAR_LINK:
      return {
        ...state,
        link: null,
      };
    default:
      return state;
  }
};

export default rolesSelectReducer;
